/**
 * Centralized environment configuration.
 * All env var access with fallback defaults lives here.
 * Vite injects VITE_-prefixed vars at build time via import.meta.env.
 */

const env = (
  import.meta as unknown as { env: Record<string, string | undefined> }
).env;

/** Base URL of the web app (e.g. https://yuklar.com) */
export const APP_URL: string = env.VITE_APP_URL || "";

/** Base URL of the backend API (e.g. https://yuklar.com/api) */
export const API_BASE_URL: string = env.VITE_API_URL || "http://localhost:8585";

/** WebSocket URL (e.g. wss://yuklar.com/ws) */
export const WS_URL: string = env.VITE_WS_URL || "ws://localhost:8080";

// ── Sentry (error monitoring + session replay) ──
// These are the BUILD-TIME defaults, used for local dev. In prod the values
// are overridden at container start via `/runtime-config` (see
// docker/runtime-config-entrypoint.sh), so Sentry can be toggled per-deploy
// without rebuilding. Sentry stays fully disabled unless a DSN is present.

/** Sentry DSN. Empty string = Sentry disabled (never initializes). */
export const SENTRY_DSN: string = env.VITE_SENTRY_DSN || "";

/** Explicit kill-switch. Set VITE_SENTRY_ENABLED="false" to force-disable. */
export const SENTRY_ENABLED: boolean = env.VITE_SENTRY_ENABLED !== "false";

/** Environment label shown in Sentry (e.g. "production", "dev.yuklar.com"). */
export const SENTRY_ENVIRONMENT: string =
  env.VITE_SENTRY_ENVIRONMENT || (env.PROD ? "production" : "development");
